/** Albanian is the source dictionary; en.ts must provide every key (checked by the type). */
export const sq = {
  'app.name': 'Fjalim',
  'app.tagline': 'Transkriptim dhe titra në shqip',
  'nav.skip': 'Kalo te përmbajtja',
  'nav.main': 'Navigimi kryesor',
  'nav.transcriptions': 'Transkriptimet',
  'nav.keys': 'Çelësat e API-së',
  'nav.billing': 'Balanca',
  'nav.admin': 'Administrimi',
  'nav.logout': 'Dil',
  'nav.login': 'Hyr',
  'nav.signup': 'Regjistrohu',
  'theme.label': 'Tema',
  'theme.light': 'E çelët',
  'theme.dark': 'E errët',
  'theme.system': 'Si sistemi',
  'lang.label': 'Gjuha',
  'balance.label': 'Balanca',
  'common.loading': 'Po ngarkohet…',
  'common.save': 'Ruaj',
  'common.cancel': 'Anulo',
  'common.delete': 'Fshi',
  'common.close': 'Mbyll',
  'common.copy': 'Kopjo',
  'common.copied': 'U kopjua',
  'common.retry': 'Provo përsëri',
  'common.back': 'Mbrapa',
  'common.optional': 'opsional',
  'common.never': 'Asnjëherë',
  'common.minutes': '{n} min',
  'dur.h': 'orë',
  'dur.min': 'min',
  'dur.s': 's',

  'err.generic': 'Diçka shkoi keq. Provoni përsëri.',
  'err.network_error': 'Serveri nuk u arrit. Kontrolloni lidhjen.',
  'err.invalid_credentials': 'Email-i ose fjalëkalimi është i gabuar.',
  'err.invalid_token': 'Lidhja nuk vlen ose ka skaduar.',
  'err.insufficient_credits': 'Balanca nuk mjafton. Rimbusheni për të vazhduar.',
  'err.rate_limited': 'Shumë kërkesa. Prisni pak dhe provoni përsëri.',
  'err.too_many_keys': 'Keni arritur kufirin e çelësave aktivë.',
  'err.billing_unavailable': 'Pagesat nuk janë të disponueshme tani.',
  'err.version_conflict': 'Një version më i ri u ruajt diku tjetër.',
  'err.not_found': 'Nuk u gjet.',
  'err.unauthorized': 'Hyni përsëri për të vazhduar.',
  'err.upload_incomplete': 'Ngarkimi nuk përfundoi. Provoni përsëri.',
  'err.size_mismatch': 'Ngarkimi nuk përfundoi. Provoni përsëri.',
  'err.validation_error': 'Kontrolloni fushat dhe provoni përsëri.',
  'err.email_not_allowed': 'Ky shërbim emaili nuk pranohet. Përdorni një adresë tjetër.',
  'err.turnstile_failed': 'Kontrolli i sigurisë nuk u kalua. Provoni përsëri.',

  'auth.field.email': 'Email',
  'auth.field.password': 'Fjalëkalimi',
  'auth.field.newPassword': 'Fjalëkalimi i ri',
  'auth.field.name': 'Emri',
  'auth.field.passwordHint': 'Të paktën 10 karaktere.',
  'auth.login.title': 'Hyr në Fjalim',
  'auth.login.lead': 'Vazhdoni aty ku e latë.',
  'auth.login.submit': 'Hyr',
  'auth.login.noAccount': 'Nuk keni llogari?',
  'auth.login.terms': 'Duke hyrë, pranoni Kushtet e shërbimit dhe Politikën e privatësisë.',
  'auth.signup.title': 'Krijo llogari',
  'auth.signup.lead': 'Verifikoni email-in dhe merrni {minutes} minuta transkriptim falas.',
  'auth.signup.submit': 'Krijo llogarinë',
  'auth.signup.check.title': 'Kontrollo email-in tënd',
  'auth.signup.check.body': 'Ju dërguam një email me hapat e radhës. Hapeni për të vazhduar, ose hyni nëse keni tashmë një llogari.',
  'auth.signup.haveAccount': 'Keni llogari?',
  'auth.signup.terms': 'Pranoj Kushtet e shërbimit dhe Politikën e privatësisë.',
  'auth.forgot.link': 'Harruat fjalëkalimin?',
  'auth.forgot.title': 'Rivendos fjalëkalimin',
  'auth.forgot.lead': 'Shkruani email-in dhe do t’ju dërgojmë një lidhje.',
  'auth.forgot.submit': 'Dërgo lidhjen',
  'auth.forgot.sent': 'Nëse ekziston një llogari me këtë email, lidhja është dërguar.',
  'auth.reset.title': 'Fjalëkalim i ri',
  'auth.reset.submit': 'Ruaj fjalëkalimin',
  'auth.reset.done': 'Fjalëkalimi u ndryshua. Hyni me fjalëkalimin e ri.',
  'auth.reset.missing': 'Kjo lidhje është e paplotë. Kërkoni një tjetër.',
  'auth.verify.title': 'Verifikimi i email-it',
  'auth.verify.working': 'Po verifikojmë email-in…',
  'auth.verify.done': 'Email-i u verifikua.',
  'auth.verify.grant': 'Ju shtuam {minutes} minuta transkriptim falas.',
  'auth.verify.noGrant': 'Llogaria juaj është e verifikuar.',
  'auth.verify.failed': 'Lidhja nuk vlen ose ka skaduar.',
  'auth.verify.continue': 'Vazhdo te transkriptimet',
  'auth.verify.missing': 'Kjo lidhje është e paplotë.',
  'auth.pending.title': 'Verifikoni email-in',
  'auth.pending.body': 'Ju dërguam një lidhje te {email}. Pas verifikimit merrni {minutes} minuta falas.',
  'auth.pending.resend': 'Dërgo përsëri',
  'auth.pending.sent': 'Lidhja u dërgua përsëri.',
  'auth.pending.already': 'Email-i është tashmë i verifikuar.',

  'list.title': 'Transkriptimet',
  'list.heading': 'Regjistrimet tuaja',
  'list.upload.cta': 'Ngarko regjistrime',
  'list.drop.title': 'Hidhni regjistrimet këtu',
  'list.drop.hint': 'ose shtypni për të zgjedhur · audio dhe video, deri në 2 GB për regjistrim',
  'list.drop.active': 'Lëshoni për të ngarkuar',
  'list.filters': 'Kërkimi dhe filtrat',
  'list.search.label': 'Kërko regjistrime',
  'list.search.placeholder': 'Kërko sipas emrit të regjistrimit',
  'list.filter.all': 'Të gjitha',
  'list.filter.completed': 'Gati',
  'list.filter.processing': 'Në përpunim',
  'list.filter.queued': 'Në radhë',
  'list.filter.failed': 'Dështuan',
  'list.sort.label': 'Renditja',
  'list.sort.newest': 'Më të rejat',
  'list.sort.oldest': 'Më të vjetrat',
  'list.sort.duration': 'Kohëzgjatja',
  'list.results.one': '{n} regjistrim',
  'list.results.other': '{n} regjistrime',
  'list.clear': 'Pastro',
  'list.emptyFiltered.title': 'Asnjë regjistrim nuk përputhet',
  'list.emptyFiltered.reset': 'Rivendos filtrat',
  'list.empty.title': 'Ende asnjë transkriptim',
  'list.empty.body': 'Ngarkoni një regjistrim audio ose video. Transkripti shfaqet këtu brenda pak minutash.',
  'list.col.name': 'Emri',
  'list.col.status': 'Gjendja',
  'list.col.duration': 'Kohëzgjatja',
  'list.col.cost': 'Kostoja',
  'list.col.created': 'Krijuar',
  'list.status.queued': 'Në radhë',
  'list.status.processing': 'Po përpunohet',
  'list.status.completed': 'Gati',
  'list.status.failed': 'Dështoi',
  'list.status.canceled': 'Anuluar',
  'list.upload.uploading': 'Po ngarkohet {pct}%',
  'list.upload.starting': 'Po krijojmë transkriptimin…',
  'list.upload.done': 'U ngarkua',
  'list.upload.failed': 'Ngarkimi dështoi',
  'list.upload.tooBig': 'Regjistrimi është mbi 2 GB.',
  'list.upload.dismiss': 'Hiq nga lista',
  'list.upload.retry': 'Provo përsëri',
  'list.untitled': 'Pa emër',
  'list.open': 'Hap',
  'list.delete': 'Fshi',
  'list.delete.title': 'Të fshihet transkriptimi?',
  'list.delete.body': 'Fshihen audioja dhe të gjitha versionet e transkriptit. Kjo nuk kthehet mbrapsht.',
  'list.delete.confirm': 'Fshi përgjithmonë',
  'list.more': 'Shfaq më shumë',
  'list.lowBalance': 'Balanca është e ulët. Rimbusheni për të transkriptuar.',
  'list.topup': 'Rimbush',
  'list.live': 'Lista përditësohet vetë.',
  'list.uploadsHeading': 'Ngarkimet',
  'list.empty.step1': 'Ngarkoni një regjistrim audio ose video.',
  'list.empty.step2': 'Prisni disa minuta. Transkripti shfaqet këtu vetë.',
  'list.empty.step3': 'Korrigjoni fjalët, folësit dhe kohët, pastaj eksportoni TXT, SRT ose VTT.',
  'list.speakers.toggle': 'Ndaj folësit (+{price} në minutë)',
  'list.speakers.countLabel': 'Numri i folësve',
  'list.speakers.auto': 'Automatik',
  'list.speakers.one': '{n} folës',
  'list.speakers.other': '{n} folës',

  'editor.back': 'Transkriptimet',
  'editor.tab.transcript': 'Transkripti',
  'editor.tab.captions': 'Titrat',
  'editor.tabs': 'Pamjet e redaktorit',
  'editor.loading': 'Po hapim transkriptin…',
  'editor.notReady': 'Ky transkriptim nuk është gati ({status}).',
  'editor.failed': 'Transkriptimi dështoi: {message}',
  'editor.noAudio': 'Audioja nuk është e disponueshme.',
  'editor.reload': 'Ringarko',
  'editor.segments': 'Segmentet e transkriptit',
  'editor.empty': 'Transkripti është bosh.',
  'player.label': 'Luajtësi',
  'player.play': 'Luaj',
  'player.pause': 'Pusho',
  'player.back5': 'Mbrapa 5 s',
  'player.fwd5': 'Përpara 5 s',
  'player.speed': 'Shpejtësia',
  'player.seek': 'Pozicioni',
  'player.follow': 'Ndiq leximin',
  'seg.time': 'Shko te {time}',
  'seg.seekHint': 'Kliko dy herë mbi një fjalë për të shkuar te audioja e saj',
  'seg.editing': 'Teksti i segmentit',
  'seg.speaker': 'Folësi',
  'seg.speaker.none': 'Pa folës',
  'seg.speaker.rename': 'Riemërto',
  'seg.speaker.renamed': 'Të gjithë folësit u riemërtuan.',
  'seg.speaker.new': '＋ Folës i ri…',
  'seg.speaker.newName': 'Emri i folësit të ri',
  'seg.speaker.add': 'Shto',
  'seg.speaker.renameAll': 'Riemërto kudo',
  'seg.speaker.renameTo': 'Emri i ri i folësit',
  'seg.start': 'Fillimi',
  'seg.end': 'Mbarimi',
  'seg.split': 'Ndaj te kursori',
  'seg.merge': 'Bashko me tjetrin',
  'seg.menu': 'Veprimet e segmentit',
  'seg.more': 'Më shumë veprime',
  'seg.more.tip': 'Më shumë veprime për segmentin: ndaj, bashko, ndrysho folësin, vendos kohët, fshi (klikimi i djathtë ose Shift+F10)',
  'seg.split.tip': 'Ndaj segmentin te kursori ({key})',
  'seg.merge.tip': 'Bashko këtë segment me segmentin që vjen pas tij',
  'seg.mergePrev': 'Bashko me të mëparshmin',
  'seg.speaker.change': 'Ndrysho folësin…',
  'seg.setStart': 'Vendos fillimin këtu',
  'seg.setEnd': 'Vendos mbarimin këtu',
  'seg.delete': 'Fshi segmentin',
  'seg.delete.title': 'Të fshihet segmenti?',
  'seg.delete.body': 'Segmenti hiqet nga transkripti bashkë me kohët e tij.',
  'seg.delete.confirm': 'Fshi',
  'shortcuts.next': 'Përfundo segmentin dhe kalo te tjetri',
  'shortcuts.split': 'Ndaj segmentin te kursori',
  'shortcuts.seekWord': '+ klikim mbi një fjalë: luaj nga ajo fjalë',
  'shortcuts.menu': 'Hap menynë e segmentit (ose klikim i djathtë)',
  'cap.split.tip': 'Ndaj titrin te kursori',
  'cap.merge.tip': 'Bashko këtë titër me titrin që vjen pas tij',
  'cap.delete.tip': 'Fshi këtë titër',
  'cap.tools': 'Veprimet e titrit {n}',
  'cap.col.text': 'Teksti',
  'cap.col.speaker': 'Folësi',
  'time.here': 'Vendos këtu',
  'time.here.label': 'Vendos {edge} te pozicioni aktual i luajtjes',
  'time.notice.negative': 'Koha nuk mund të jetë negative. E rregulluam.',
  'time.notice.reversed': 'Fillimi duhet të jetë para mbarimit. E rregulluam kohën.',
  'time.notice.overlapPrev': 'Segmenti nuk mund të fillojë para mbarimit të segmentit të mëparshëm. E rregulluam kohën.',
  'time.notice.overlapNext': 'Segmenti nuk mund të mbarojë pas fillimit të segmentit tjetër. E rregulluam kohën.',
  'find.open': 'Gjej',
  'find.title': 'Gjej dhe zëvendëso',
  'find.query': 'Gjej',
  'find.replacement': 'Zëvendëso me',
  'find.ignoreCase': 'Pa dallim shkronjash të mëdha dhe të vogla',
  'find.count': '{current} nga {total}',
  'find.none': 'Asnjë rezultat',
  'find.next': 'Tjetri',
  'find.prev': 'I mëparshmi',
  'find.replaceOne': 'Zëvendëso',
  'find.replaceAll': 'Zëvendëso të gjitha',
  'find.replaced.one': 'U zëvendësua {n} rast.',
  'find.replaced.other': 'U zëvendësuan {n} raste.',
  'find.close': 'Mbyll kërkimin',
  'find.hintDiacritics': 'ë dhe e, ç dhe c janë shkronja të ndryshme.',
  'save.saved': 'U ruajt · versioni {n}',
  'save.savedCompact': 'U ruajt · v{n}',
  'save.saving': 'Po ruhet…',
  'save.unsaved': 'Ndryshime të paruajtura',
  'save.error': 'Ruajtja dështoi. Provojmë përsëri me ndryshimin e radhës.',
  'save.now': 'Ruaj',
  'save.conflict': 'Një version më i ri u ruajt diku tjetër. Ta ringarkojmë?',
  'save.conflictHint': 'Ringarkimi humbet ndryshimet e paruajtura.',
  'guard.leave': 'Keni ndryshime të paruajtura. Doni të largoheni?',
  'guard.stay': 'Qëndro',
  'guard.discard': 'Largohu pa ruajtur',
  'export.label': 'Eksporto',
  'export.txt': 'TXT',
  'export.txt-timestamps': 'TXT me kohë',
  'export.srt': 'SRT',
  'export.vtt': 'VTT',
  'export.json': 'JSON',
  'export.failed': 'Eksportimi dështoi. Provoni përsëri.',
  'export.transcript': 'Transkripti',
  'export.captions': 'Titrat',
  'export.for': 'Për',
  'export.go': 'Shkarko',
  'export.busy': 'Po përgatitet…',
  'export.hint.one': '{aspect}, {n} rresht, deri në {chars} shkronja',
  'export.hint.other': '{aspect}, {n} rreshta, deri në {chars} shkronja',
  'export.edited': 'Titrat tuaj të redaktuar eksportohen siç janë; “Për” ndikon vetëm te titrat e ndërtuar automatikisht.',

  'pv.title': 'Pamja',
  'editor.stage.show': 'Shfaq pamjen',
  'editor.stage.hide': 'Fshih pamjen',
  'pv.platform': 'Platforma',
  'pv.chip.youtube': 'YouTube',
  'pv.chip.youtube-shorts': 'Shorts',
  'pv.chip.tiktok': 'TikTok',
  'pv.chip.instagram-reels': 'Reels',
  'pv.chip.instagram': 'Instagram',
  'pv.chip.facebook': 'Facebook',
  'pv.chip.linkedin': 'LinkedIn',
  'pv.chip.x': 'X',
  'pv.chip.broadcast': 'Lajme/TV',
  'pv.frame': 'Pamja e videos me titra ({aspect})',
  'pv.safe': 'Shfaq zonën e sigurt',
  'pv.safeNote': 'Përafërsisht ku platforma vendos butonat dhe përshkrimin.',
  'pv.audioNote': 'Burimi është audio: titrat vendosen mbi ngjyrën e fushës.',
  'pv.styles': 'Stile të gatshme',
  'pv.style.classic': 'Klasik',
  'pv.style.box': 'Kuti',
  'pv.style.tiktok': 'TikTok',
  'pv.style.news': 'Lajme',
  'pv.font': 'Shkronjat',
  'pv.font.grotesk': 'Grotesk',
  'pv.font.condensed': 'Të ngushta',
  'pv.font.serif': 'Serif',
  'pv.size': 'Madhësia',
  'pv.color': 'Ngjyra e tekstit',
  'pv.bg': 'Sfondi',
  'pv.bg.none': 'Asnjë',
  'pv.bg.outline': 'Kontur',
  'pv.bg.box': 'Kuti',
  'pv.bgColor': 'Ngjyra e sfondit',
  'pv.bgOpacity': 'Dendësia',
  'pv.position': 'Pozicioni',
  'pv.position.bottom': 'Poshtë',
  'pv.position.middle': 'Në mes',
  'pv.position.top': 'Lart',
  'pv.uppercase': 'Shkronja të mëdha',
  'pv.highlight': 'Thekso fjalën që thuhet',
  'pv.highlightColor': 'Ngjyra e theksit',
  'pv.canvas': 'Ngjyra e fushës',
  'pv.framing': 'Kornizimi',
  'pv.framing.fit': 'E plotë',
  'pv.framing.crop': 'E prerë',
  'pv.framingNote.fit': 'Videoja del e plotë; sfondi është një kopje e turbulluar.',
  'pv.framingNote.crop': 'Videoja mbush kornizën dhe skajet priten.',
  'render.title': 'Videot',
  'render.create': 'Krijo video me titra',
  'render.creating': 'Po dërgohet…',
  'render.price.free': 'Falas',
  'render.price.freeLeft.one': 'Falas — ju ka mbetur {n} video falas',
  'render.price.freeLeft.other': 'Falas — ju kanë mbetur {n} video falas',
  'render.price.paid': 'Kushton {amount} ({n} min)',
  'render.pricing': '{free} video falas për llogari, pastaj {amount} në minutë.',
  'render.cost.free': 'Falas',
  'render.cost.refunded': 'Nuk u tarifua',
  'render.topup': 'Rimbushni balancën',
  'render.firstJob': 'Videoja e parë mund të marrë disa minuta.',
  'render.for': 'Për {platform}',
  'render.empty': 'Videot me titra që krijoni shfaqen këtu.',
  'render.status.queued': 'Në radhë',
  'render.status.processing': 'Po krijohet',
  'render.status.completed': 'Gati',
  'render.status.failed': 'Dështoi',
  'render.status.canceled': 'Anuluar',
  'render.download': 'Shkarko',
  'render.expires': 'fshihet më {date}',
  'render.retry': 'Provo përsëri',
  'render.remove': 'Hiq',
  'render.failed': 'Videoja nuk u krijua. Provoni përsëri.',
  'render.framing.fit': 'e plotë',
  'render.framing.crop': 'e prerë',
  'err.render_limit': 'Keni dy video në krijim. Prisni të mbarojë njëra dhe provoni përsëri.',
  'err.source_too_long': 'Burimi është mbi 30 minuta. Videot me titra mbështesin deri në 30 minuta.',
  'err.no_source_media': 'Regjistrimi origjinal nuk është ruajtur, ndaj nuk mund të krijohet video me titra.',
  'shortcuts.title': 'Shkurtoret e tastierës',
  'shortcuts.playPause': 'Luaj / pusho',
  'shortcuts.back5': 'Mbrapa 5 sekonda',
  'shortcuts.fwd5': 'Përpara 5 sekonda',
  'shortcuts.save': 'Ruaj',
  'shortcuts.find': 'Gjej dhe zëvendëso',
  'shortcuts.help': 'Shfaq ose mbyll këtë listë',
  'shortcuts.hint': 'Shtypni ? për shkurtoret',
  'shortcuts.open': 'Shkurtoret',

  'cap.title': 'Titrat',
  'cap.preview': 'Pamja paraprake e titrit',
  'cap.audioPanel': 'Titri që shfaqet tani',
  'cap.derived': 'Titrat ndërtohen nga transkripti. Redaktimi i parë i ruan si titra të pavarur.',
  'cap.edited': 'Titrat janë redaktuar dhe nuk ndjekin më ndryshimet e transkriptit.',
  'cap.cue': 'Titri {n}',
  'cap.text': 'Teksti i titrit {n}',
  'cap.start': 'Fillimi',
  'cap.end': 'Mbarimi',
  'cap.nudge': '{edge} {delta} s',
  'cap.split': 'Ndaj te kursori',
  'cap.split.tooShort': 'Titri është shumë i shkurtër për t’u ndarë.',
  'cap.merge': 'Bashko me tjetrin',
  'cap.delete': 'Fshi titrin',
  'cap.seek': 'Shko te titri',
  'cap.seekHint': 'Kliko dy herë për të shkuar te fillimi i këtij titri',
  'cap.speaker': 'Folësi i titrit {n}',
  'cap.warnings.one': '{n} paralajmërim',
  'cap.warnings.other': '{n} paralajmërime',
  'cap.errors.one': '{n} gabim',
  'cap.errors.other': '{n} gabime',
  'cap.allGood': 'Të gjitha titrat janë në rregull.',
  'cap.regen': 'Rindërto nga transkripti',
  'cap.regen.title': 'Të rindërtohen titrat?',
  'cap.regen.body': 'Redaktimet e titrave zëvendësohen me titra të rinj nga fjalët e transkriptit, me rregullat e mësipërme.',
  'cap.regen.confirm': 'Rindërto',
  'cap.rules': 'Rregullat e titrave',
  'cap.rule.maxCharsPerLine': 'Karaktere për rresht',
  'cap.rule.maxLines': 'Rreshta për titër',
  'cap.rule.maxCps': 'Karaktere në sekondë',
  'cap.rule.minDuration': 'Kohëzgjatja më e shkurtër (s)',
  'cap.rule.maxDuration': 'Kohëzgjatja më e gjatë (s)',
  'cap.rule.minGap': 'Hapësira më e vogël (s)',
  'cap.rule.reset': 'Rivendos standardet',
  'cap.import': 'Importo SRT ose VTT',
  'cap.import.failed': 'Titrat nuk u lexuan si SRT ose VTT.',
  'cap.import.empty': 'Nuk u gjet asnjë titër.',
  'cap.empty': 'Nuk ka titra.',
  'cap.issue.line_too_long': 'Rreshti është shumë i gjatë.',
  'cap.issue.too_many_lines': 'Ka shumë rreshta.',
  'cap.issue.cps_too_high': 'Lexohet shumë shpejt.',
  'cap.issue.too_short': 'Shfaqet shumë shkurt.',
  'cap.issue.too_long': 'Shfaqet shumë gjatë.',
  'cap.issue.overlap': 'Përputhet me titrin tjetër.',
  'cap.issue.gap_too_small': 'Hapësira me titrin tjetër është shumë e vogël.',
  'cap.issue.empty': 'Titri është bosh.',
  'cap.issue.negative_duration': 'Mbarimi është para fillimit.',

  'keys.title': 'Çelësat e API-së',
  'keys.docs': 'Dokumentimi i API-t',
  'keys.authDocs': 'Si ta përdorni çelësin API',
  'webhook.docs': 'Konfiguroni dhe verifikoni webhook-et',
  'keys.lead': 'Përdorni çelësat për të thirrur API-në nga programet tuaja. Çdo çelës shfaqet vetëm një herë.',
  'keys.create': 'Krijo çelës',
  'keys.name': 'Emri i çelësit',
  'keys.name.placeholder': 'p.sh. Prodhimi',
  'keys.created': 'Çelësi u krijua. Kopjojeni tani, nuk do ta shihni më.',
  'keys.list': 'Çelësat tuaj',
  'keys.empty': 'Ende asnjë çelës.',
  'keys.prefix': 'Fillimi',
  'keys.createdAt': 'Krijuar',
  'keys.lastUsed': 'Përdorur së fundi',
  'keys.revoke': 'Anulo çelësin',
  'keys.revoke.title': 'Të anulohet çelësi?',
  'keys.revoke.body': 'Programet që e përdorin do të marrin gabim 401 menjëherë.',
  'keys.revoked': 'Anuluar',
  'webhook.title': 'Sekreti i webhook-ut',
  'webhook.lead': 'Çdo webhook nënshkruhet me këtë sekret në kokën Fjalim-Signature.',
  'webhook.reveal': 'Shfaq',
  'webhook.hide': 'Fshih',
  'webhook.rotate': 'Ndrysho sekretin',
  'webhook.rotate.title': 'Të ndryshohet sekreti?',
  'webhook.rotate.body': 'Sekreti i vjetër pushon së vlefshmi menjëherë. Përditësoni programet tuaja.',
  'webhook.rotated': 'Sekreti u ndryshua.',
  'curl.title': 'Shembull me curl',
  'curl.lead': 'Zëvendësoni fj_live_… me çelësin tuaj.',

  'billing.title': 'Balanca',
  'billing.balance': 'Balanca aktuale',
  'billing.expires': 'Skadon më {date}',
  'billing.minutesLeft.one': 'rreth {minutes} minutë transkriptim',
  'billing.minutesLeft.other': 'rreth {minutes} minuta transkriptim',
  'billing.topup': 'Rimbush',
  'billing.custom': 'Shumë tjetër',
  'billing.custom.hint': 'Nga €{min} deri në €{max}, në euro të plota.',
  'billing.pay': 'Vazhdo te pagesa',
  'billing.redirecting': 'Po ju çojmë te pagesa…',
  'billing.invalidAmount': 'Shkruani një shumë të plotë nga €{min} deri në €{max}.',
  'billing.success': 'Pagesa u pranua. Balanca përditësohet brenda pak sekondash.',
  'billing.canceled': 'Pagesa u anulua. Nuk u tërhoq asgjë.',
  'billing.price.title': 'Çmimi',
  'billing.price.line': 'Nga {price} në minutë, e faturuar për çdo sekondë të nisur.',
  'billing.price.list': 'Lista e çmimeve',
  'billing.price.fast': 'I shpejtë',
  'billing.price.accurate': 'I saktë',
  'billing.price.speakers': 'Ndarja e folësve',
  'billing.price.perMinute': '{price}/min',
  'billing.price.addon': '+{price}/min',
  'billing.price.active': 'Aktiv',
  'billing.price.soon': 'Së shpejti',
  'billing.price.planned': 'Çmimet e planifikuara mund të ndryshojnë.',
  'billing.ledger': 'Lëvizjet',
  'billing.ledger.empty': 'Ende asnjë lëvizje.',
  'billing.ledger.more': 'Shfaq më shumë',
  'billing.usage': 'Përdorimi ditor',
  'billing.usage.empty': 'Nuk ka përdorim në 30 ditët e fundit.',
  'ledger.topup': 'Rimbushje',
  'ledger.signup_grant': 'Minuta falas',
  'ledger.usage': 'Transkriptim',
  'ledger.usage_addon': 'Ndarja e folësve',
  'ledger.usage_refund': 'Rimbursim transkriptimi',
  'ledger.refund': 'Rimbursim pagese',
  'ledger.adjustment': 'Rregullim',
  'ledger.render': 'Video me titra',
  'ledger.render_refund': 'Rimbursim videoje me titra',
  'ledger.expiry': 'Kredi e skaduar',
  'ledger.date': 'Data',
  'ledger.kind': 'Lloji',
  'ledger.amount': 'Shuma',

  'admin.title': 'Administrimi',
  'admin.lead': 'Pa abonime: të ardhurat janë rimbushjet minus rimbursimet e Stripe në 30 ditët e fundit.',
  'admin.kpis': 'Shifrat kryesore',
  'admin.kpi.revenue': 'Të ardhurat 30 ditë',
  'admin.kpi.refunds': 'Rimbursime 30 ditë',
  'admin.kpi.runRate': 'Ritmi mujor',
  'admin.kpi.paying': 'Llogari që paguajnë',
  'admin.kpi.active': 'Llogari aktive',
  'admin.kpi.minutes': 'Minuta 30 ditë',
  'admin.kpi.usage': 'Përdorimi 30 ditë',
  'admin.kpi.held': 'Balanca të klientëve',
  'admin.kpi.owed': 'Borxhe të klientëve',
  'admin.kpi.cost': 'Kosto e vlerësuar e llogaritjes',
  'admin.daily': 'Ditore',
  'admin.chart': 'Minutat dhe të ardhurat ditore',
  'admin.legend.minutes': 'Minutat',
  'admin.legend.revenue': 'Të ardhurat',
  'admin.accounts': 'Llogaritë',
  'admin.search': 'Kërko email',
  'admin.sort.spend': 'Shpenzimi',
  'admin.sort.recent': 'Më të rejat',
  'admin.sort.minutes': 'Minutat',
  'admin.col.email': 'Email',
  'admin.col.minutes': 'Minuta 30 ditë',
  'admin.col.spend': 'Shpenzimi 30 ditë',
  'admin.col.balance': 'Balanca',
  'admin.unitMinutes': '{n} min',
  'admin.test': 'provë',
  'admin.empty': 'Nuk ka llogari.',
  'notfound.title': 'Faqja nuk u gjet',
  'notfound.body': 'Lidhja është e vjetër ose e gabuar.',
  'notfound.back': 'Kthehu te transkriptimet',
  'crash.title': 'Diçka shkoi keq',
  'crash.body': 'Redaktori hasi një gabim të papritur. Ndryshimet e ruajtura janë të sigurta.',
  'crash.reload': 'Rifresko faqen',
} as const

export type MessageKey = keyof typeof sq
